import React from 'react'
import './styles.scss'

interface CompanyFilterButtonsProps {
  companies: {label: string, value: number}[]
  selectedCompany: number | null
  onSelectCompany: (companyId: number | null) => void
}

export function CompanyFilterButtons({
  companies,
  selectedCompany,
  onSelectCompany
}: CompanyFilterButtonsProps) {
  if (companies.length === 0) {
    return null
  }

  return (
    <div className="company-filter-buttons">
      <div className="company-filter-buttons__label">
        Filtrar por empresa:
      </div>
      <div className="company-filter-buttons__container">
        {companies.map((company) => (
          <button
            key={company.value}
            type="button"
            className={`company-filter-button ${
              selectedCompany === company.value ? 'active' : ''
            }`}
            onClick={() => onSelectCompany(company.value)}
          >
            {company.label}
          </button>
        ))}
      </div>
    </div>
  )
}
